import { AppApiGateway } from '@repo/api/web/AppApiGateway'
import type {
  ResourcesGetFileRequestQuery,
  ResourcesGetFileLocationRequestQuery,
} from '@repo/api/web/models'
import { inject, injectable } from 'inversify'
import { useAppConfig } from 'nuxt/app'

import type { CreateResource } from '../Models/CreateResource'

@injectable()
export class ResourceService {
  protected appConfig: ReturnType<typeof useAppConfig>

  constructor(
    @inject(AppApiGateway)
    readonly api: AppApiGateway,
  ) {
    this.appConfig = useAppConfig()
  }

  getFile(id: string, query: ResourcesGetFileRequestQuery) {
    return this.api.resourcesGetFile(id, this.appConfig.host, query)
  }

  getFileLocation(id: string, query: ResourcesGetFileLocationRequestQuery) {
    return this.api.resourcesGetFileLocation(id, this.appConfig.host, query)
  }

  create(model: CreateResource) {
    return this.api
      .resourcesCreate(this.appConfig.host, model)
      .then(r => r.id)
  }
}
